import { render } from "./CoolpadMallPC.vue?vue&type=template&id=64729d54"
import script from "./CoolpadMallPC.vue?vue&type=script&lang=js"
export * from "./CoolpadMallPC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__